// services/lincah/lincah-auth.ts — Lincah client PER-BRAND via S2 proxy
// Semua call → `${getApiUrl()}/api/lincah/{brandId}/{path}` (S2 resolve
// apiToken+partnerId brand → fallback GLOBAL). Secret TIDAK pernah ke browser.

import { getApiUrl, API_KEY } from '../apiConfig';
import { backendHeaders } from '../apiAuth';

export async function lincahFetch(brandId: string, path: string, init?: RequestInit): Promise<Response> {
  const base: Record<string, string> = {};
  (new Headers(init?.headers || {})).forEach((v, k) => { base[k] = v; });
  const headers = new Headers(await backendHeaders(base, API_KEY));
  if (init?.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const url = `${getApiUrl()}/api/lincah/${encodeURIComponent(brandId)}${path}`;
  return fetch(url, { ...init, headers });
}
